import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from '@mui/material';
import { useApiGet } from '../../../utils/httpClientTs';
import { getRosterDuesAccess } from '../../../endpoints/rosterDues';

const RosterDuesLanding: React.FC = () => {
  const navigate = useNavigate();

  const { data: accessData, isLoading } = useApiGet(
    ['roster-dues-access'],
    () => getRosterDuesAccess(),
    {
      enabled: true,
      retry: 1,
    }
  );

  useEffect(() => {
    // Auto-redirect if no SPD access
    if (accessData && !accessData.has_spd_access) {
      navigate('/annual-reports/roster-dues/local-chapters', { replace: true });
    }
  }, [accessData, navigate]);

  if (isLoading) {
    return (
      <Grid container padding={4} justifyContent="center">
        <CircularProgress />
      </Grid>
    );
  }

  // If no SPD access, show loading while redirecting
  if (!accessData?.has_spd_access) {
    return (
      <Grid container padding={4} justifyContent="center">
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12} padding={1} textAlign="center">
        <Typography variant="h4" color="primary">
          Roster & Dues Forms
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 2, mb: 4 }}
        >
          Select the type of forms you want to manage
        </Typography>
      </Grid>

      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={6} md={5}>
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6,
              },
            }}
            onClick={() =>
              navigate('/annual-reports/roster-dues/local-chapters')
            }
          >
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h5" color="primary" gutterBottom>
                Local Chapter Forms
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Manage individual chapter roster and dues forms. Review member
                statuses, update assignments, and submit for approval.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={5}>
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 6,
              },
            }}
            onClick={() => navigate('/annual-reports/roster-dues/spd')}
          >
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h5" color="primary" gutterBottom>
                SPD Forms
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Review and approve SPD-level rollup forms. These forms aggregate
                data from all local chapter forms within the SPD.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RosterDuesLanding;
